import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { CODE_CHECKER_PATH } from "utils/constants/paths";

const CodeChecker = Loadable(React.lazy(() => import("./View")));

export const CodeCheckerRoute: IRouteItem = {
  path: CODE_CHECKER_PATH,
  iconName: "SearchStatus1",
  element: React.createElement(CodeChecker),
  name: "Code Checker",
  accessKeys: ["CodeGenerator"],
};
